// extracted by mini-css-extract-plugin
module.exports = {"editProfile":"EditProfile_editProfile__2HHkq","icon":"EditProfile_icon__3LLNf"};